<template>
  <div>
    <div class="synopsis">
      河南博为智能科技有限公司（简称：博为智能）成立于2016年02月16日，位于河南省郑州市高新技术产业开发区绿梅街59号柯耐特科技园3号楼3层，注册资金3500万元，是一家依托“工业物联网+人工智能”技术为基础的高新技术企业，荣膺“国家高新技术企业”、“省级专精特新企业”等资质认证。公司以打造“高可靠运行、智能化集成”的工业智能生态为使命，聚焦物联网信息产品的研发制造、技术服务和系统集成，主要产品矩阵包含高算力边缘计算主机、工业智能网关、串口服务器、工业I/O模块、电力行业终端等物联网产品，可提供覆盖设备感知、边缘计算到智能决策的全栈式解决方案。      <br />
      <br />
      深耕电力行业多年，公司对自主研发的机房动力与环境监控系统、智能变电站辅助监控平台、远程智能巡视系统，集成智能算法进行持续迭代；核心产品实现全链条自主可控，拥有多项软件著作权，通过CNAS等权威实验室检测认证；公司秉承工业互联网协议规范的开发标准，坚持工业物联网领域数据深度计算的技术路线，深化软硬件深度融合的创新方向，同时向智慧教育、交通、农业、水利、通信、军工等领域进行业务延伸拓展。      <br/>
      <br/>
    </div>
    <div class="synopsis-static">
      <div class="synopsis-static-item">
        <div>3500万</div>
        <div>注册资金3500万元</div>
      </div>
      <div class="synopsis-static-item">
        <div>30+</div>
        <div>研发精英30余名</div>
      </div>
      <div class="synopsis-static-item">
        <div>90%</div>
        <div>本科以上学历90%</div>
      </div>
      <div class="synopsis-static-item">
        <div>30+</div>
        <div>知识产权30余项</div>
      </div>
      <div class="synopsis-static-item">
        <div>20+</div>
        <div> 资质认证20余项</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "synopsis",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.synopsis {
  font-size: 16px;
  color: #666666;
  line-height: 26px;
}
.synopsis-static {
  margin: 45px 0;
  display: flex;
  justify-content: space-around;
  div {
    text-align: center;
    div:nth-child(1) {
      font-weight: 400;
      font-size: 48px;
      color: #373737;
      line-height: 30px;
      margin-bottom: 15px!important;
    }
    div:nth-child(2) {
      margin-top: 5px;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 30px;
    }
  }
}
</style>
